module.exports = __webpack_public_path__ + "static/media/dotPreloader.e4f3dfa9.svg";